import { render, staticRenderFns } from "./AdvCartProductRow.vue?vue&type=template&id=489740c8"
import script from "./AdvCartProductRow.vue?vue&type=script&lang=js"
export * from "./AdvCartProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports